import React, { useEffect, useState, Component } from 'react';
import { useAdminAuth } from '../../context/AdminAuthContext';
import AdminSidebar from '../../components/admin/AdminSidebar';
import AdminHeader from '../../components/admin/AdminHeader';
import { BarChart2Icon, PieChartIcon, TrendingUpIcon, CalendarIcon, DownloadIcon, RefreshCwIcon, FilterIcon, ChevronDownIcon, ArrowUpIcon, ArrowDownIcon, DollarSignIcon, UsersIcon, FileTextIcon, CheckCircleIcon, ClockIcon, XCircleIcon, PrinterIcon, BuildingIcon, LayersIcon, ShareIcon, MailIcon, LineChartIcon, BarChartIcon, Activity, Grid, AlertCircleIcon, HelpCircleIcon, InfoIcon, MoreHorizontalIcon, ChevronRightIcon, CreditCardIcon, ArrowRightIcon } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell, AreaChart, Area } from 'recharts';
// Mock data for charts and reports
const mockRevenueData = [{
  month: 'Jan',
  revenue: 125000,
  target: 150000,
  lastYear: 100000
}, {
  month: 'Feb',
  revenue: 160000,
  target: 150000,
  lastYear: 110000
}, {
  month: 'Mar',
  revenue: 180000,
  target: 150000,
  lastYear: 120000
}, {
  month: 'Apr',
  revenue: 170000,
  target: 160000,
  lastYear: 115000
}, {
  month: 'May',
  revenue: 200000,
  target: 170000,
  lastYear: 130000
}, {
  month: 'Jun',
  revenue: 220000,
  target: 180000,
  lastYear: 140000
}, {
  month: 'Jul',
  revenue: 240000,
  target: 190000,
  lastYear: 150000
}, {
  month: 'Aug',
  revenue: 230000,
  target: 190000,
  lastYear: 145000
}, {
  month: 'Sep',
  revenue: 250000,
  target: 200000,
  lastYear: 160000
}, {
  month: 'Oct',
  revenue: 280000,
  target: 210000,
  lastYear: 175000
}, {
  month: 'Nov',
  revenue: 300000,
  target: 220000,
  lastYear: 190000
}, {
  month: 'Dec',
  revenue: 350000,
  target: 250000,
  lastYear: 210000
}];
const mockApplicationsData = [{
  month: 'Jan',
  submitted: 320,
  approved: 240,
  rejected: 30,
  pending: 50
}, {
  month: 'Feb',
  submitted: 350,
  approved: 260,
  rejected: 40,
  pending: 50
}, {
  month: 'Mar',
  submitted: 400,
  approved: 300,
  rejected: 50,
  pending: 50
}, {
  month: 'Apr',
  submitted: 380,
  approved: 280,
  rejected: 45,
  pending: 55
}, {
  month: 'May',
  submitted: 420,
  approved: 310,
  rejected: 60,
  pending: 50
}, {
  month: 'Jun',
  submitted: 450,
  approved: 330,
  rejected: 70,
  pending: 50
}, {
  month: 'Jul',
  submitted: 480,
  approved: 350,
  rejected: 80,
  pending: 50
}, {
  month: 'Aug',
  submitted: 460,
  approved: 330,
  rejected: 75,
  pending: 55
}, {
  month: 'Sep',
  submitted: 500,
  approved: 360,
  rejected: 90,
  pending: 50
}, {
  month: 'Oct',
  submitted: 550,
  approved: 400,
  rejected: 100,
  pending: 50
}, {
  month: 'Nov',
  submitted: 600,
  approved: 440,
  rejected: 110,
  pending: 50
}, {
  month: 'Dec',
  submitted: 650,
  approved: 480,
  rejected: 120,
  pending: 50
}];
const mockPaymentMethodData = [{
  name: 'Card Payment',
  value: 65
}, {
  name: 'Bank Transfer',
  value: 20
}, {
  name: 'USSD',
  value: 10
}, {
  name: 'Mobile Money',
  value: 5
}];
const mockServiceCategoryData = [{
  name: 'Business Registration',
  value: 30
}, {
  name: 'Tax Clearance',
  value: 25
}, {
  name: 'Land Documentation',
  value: 15
}, {
  name: 'Vehicle Registration',
  value: 10
}, {
  name: 'Birth/Marriage Certificates',
  value: 8
}, {
  name: 'Education Services',
  value: 7
}, {
  name: 'Health Services',
  value: 5
}];
const mockMdaRevenueData = [{
  name: 'Ministry of Finance',
  value: 35,
  fill: '#4ade80'
}, {
  name: 'Ministry of Lands',
  value: 20,
  fill: '#60a5fa'
}, {
  name: 'Ministry of Commerce',
  value: 15,
  fill: '#a78bfa'
}, {
  name: 'Ministry of Education',
  value: 10,
  fill: '#f97316'
}, {
  name: 'Ministry of Health',
  value: 8,
  fill: '#f43f5e'
}, {
  name: 'FRSC',
  value: 7,
  fill: '#facc15'
}, {
  name: 'Other MDAs',
  value: 5,
  fill: '#94a3b8'
}];
const mockUserDemographicsData = [{
  age: '18-24',
  male: 120,
  female: 150
}, {
  age: '25-34',
  male: 250,
  female: 300
}, {
  age: '35-44',
  male: 200,
  female: 220
}, {
  age: '45-54',
  male: 150,
  female: 170
}, {
  age: '55-64',
  male: 100,
  female: 120
}, {
  age: '65+',
  male: 80,
  female: 90
}];
const mockWeeklyTrendsData = [{
  day: 'Mon',
  applications: 85,
  payments: 65
}, {
  day: 'Tue',
  applications: 100,
  payments: 80
}, {
  day: 'Wed',
  applications: 110,
  payments: 90
}, {
  day: 'Thu',
  applications: 105,
  payments: 85
}, {
  day: 'Fri',
  applications: 95,
  payments: 75
}, {
  day: 'Sat',
  applications: 50,
  payments: 40
}, {
  day: 'Sun',
  applications: 30,
  payments: 25
}];
// MDA-specific data
const mockMdaData = {
  'Ministry of Finance': {
    revenueData: mockRevenueData.map(item => ({
      ...item,
      revenue: item.revenue * 0.35
    })),
    applicationsData: mockApplicationsData.map(item => ({
      ...item,
      submitted: Math.round(item.submitted * 0.3),
      approved: Math.round(item.approved * 0.3),
      rejected: Math.round(item.rejected * 0.3),
      pending: Math.round(item.pending * 0.3)
    })),
    paymentMethodData: [{
      name: 'Card Payment',
      value: 70
    }, {
      name: 'Bank Transfer',
      value: 20
    }, {
      name: 'USSD',
      value: 5
    }, {
      name: 'Mobile Money',
      value: 5
    }],
    serviceCategories: [{
      name: 'Tax Clearance',
      value: 50
    }, {
      name: 'Business Registration',
      value: 30
    }, {
      name: 'Other Services',
      value: 20
    }],
    topServices: [{
      name: 'Tax Clearance Certificate',
      count: 245,
      growth: 12
    }, {
      name: 'Business Permit Renewal',
      count: 187,
      growth: 8
    }, {
      name: 'Personal Income Tax',
      count: 156,
      growth: 5
    }, {
      name: 'Corporate Tax Filing',
      count: 134,
      growth: 15
    }, {
      name: 'Financial Statement Filing',
      count: 98,
      growth: -3
    }]
  },
  'Ministry of Lands and Surveys': {
    revenueData: mockRevenueData.map(item => ({
      ...item,
      revenue: item.revenue * 0.2
    })),
    applicationsData: mockApplicationsData.map(item => ({
      ...item,
      submitted: Math.round(item.submitted * 0.2),
      approved: Math.round(item.approved * 0.2),
      rejected: Math.round(item.rejected * 0.2),
      pending: Math.round(item.pending * 0.2)
    })),
    paymentMethodData: [{
      name: 'Card Payment',
      value: 55
    }, {
      name: 'Bank Transfer',
      value: 35
    }, {
      name: 'USSD',
      value: 5
    }, {
      name: 'Mobile Money',
      value: 5
    }],
    serviceCategories: [{
      name: 'Land Documentation',
      value: 65
    }, {
      name: 'Building Permits',
      value: 25
    }, {
      name: 'Other Services',
      value: 10
    }],
    topServices: [{
      name: 'Certificate of Occupancy',
      count: 156,
      growth: 18
    }, {
      name: 'Land Use Permit',
      count: 132,
      growth: 10
    }, {
      name: 'Building Permit',
      count: 98,
      growth: 12
    }, {
      name: 'Survey Plan Approval',
      count: 87,
      growth: 5
    }, {
      name: 'Property Registration',
      count: 76,
      growth: 8
    }]
  },
  'Ministry of Commerce and Industry': {
    revenueData: mockRevenueData.map(item => ({
      ...item,
      revenue: item.revenue * 0.15
    })),
    applicationsData: mockApplicationsData.map(item => ({
      ...item,
      submitted: Math.round(item.submitted * 0.15),
      approved: Math.round(item.approved * 0.15),
      rejected: Math.round(item.rejected * 0.15),
      pending: Math.round(item.pending * 0.15)
    })),
    paymentMethodData: [{
      name: 'Card Payment',
      value: 60
    }, {
      name: 'Bank Transfer',
      value: 25
    }, {
      name: 'USSD',
      value: 10
    }, {
      name: 'Mobile Money',
      value: 5
    }],
    serviceCategories: [{
      name: 'Business Registration',
      value: 70
    }, {
      name: 'Trade Licenses',
      value: 20
    }, {
      name: 'Other Services',
      value: 10
    }],
    topServices: [{
      name: 'Business Registration',
      count: 210,
      growth: 15
    }, {
      name: 'Business Name Reservation',
      count: 187,
      growth: 12
    }, {
      name: 'Trade License',
      count: 134,
      growth: 8
    }, {
      name: 'Market Stall Allocation',
      count: 98,
      growth: 5
    }, {
      name: 'Export Permit',
      count: 76,
      growth: 10
    }]
  },
  'Federal Road Safety Commission': {
    revenueData: mockRevenueData.map(item => ({
      ...item,
      revenue: item.revenue * 0.07
    })),
    applicationsData: mockApplicationsData.map(item => ({
      ...item,
      submitted: Math.round(item.submitted * 0.1),
      approved: Math.round(item.approved * 0.1),
      rejected: Math.round(item.rejected * 0.1),
      pending: Math.round(item.pending * 0.1)
    })),
    paymentMethodData: [{
      name: 'Card Payment',
      value: 75
    }, {
      name: 'Bank Transfer',
      value: 15
    }, {
      name: 'USSD',
      value: 8
    }, {
      name: 'Mobile Money',
      value: 2
    }],
    serviceCategories: [{
      name: 'Vehicle Registration',
      value: 55
    }, {
      name: "Driver's License",
      value: 35
    }, {
      name: 'Other Services',
      value: 10
    }],
    topServices: [{
      name: "Driver's License Renewal",
      count: 187,
      growth: 8
    }, {
      name: 'Vehicle Registration',
      count: 165,
      growth: 12
    }, {
      name: 'Number Plate Issuance',
      count: 132,
      growth: 15
    }, {
      name: 'Road Worthiness Certificate',
      count: 98,
      growth: 5
    }, {
      name: 'Change of Ownership',
      count: 76,
      growth: 10
    }]
  },
  'Ministry of Education': {
    revenueData: mockRevenueData.map(item => ({
      ...item,
      revenue: item.revenue * 0.1
    })),
    applicationsData: mockApplicationsData.map(item => ({
      ...item,
      submitted: Math.round(item.submitted * 0.12),
      approved: Math.round(item.approved * 0.12),
      rejected: Math.round(item.rejected * 0.12),
      pending: Math.round(item.pending * 0.12)
    })),
    paymentMethodData: [{
      name: 'Card Payment',
      value: 65
    }, {
      name: 'Bank Transfer',
      value: 15
    }, {
      name: 'USSD',
      value: 15
    }, {
      name: 'Mobile Money',
      value: 5
    }],
    serviceCategories: [{
      name: 'School Enrollment',
      value: 45
    }, {
      name: 'Transcript Services',
      value: 30
    }, {
      name: 'Certificate Verification',
      value: 15
    }, {
      name: 'Other Services',
      value: 10
    }],
    topServices: [{
      name: 'School Enrollment',
      count: 210,
      growth: 15
    }, {
      name: 'Transcript Request',
      count: 156,
      growth: 8
    }, {
      name: 'Certificate Verification',
      count: 132,
      growth: 12
    }, {
      name: 'Scholarship Application',
      count: 98,
      growth: 20
    }, {
      name: 'Teacher Registration',
      count: 87,
      growth: 5
    }]
  }
};
// COLORS
const COLORS = ['#4ade80', '#60a5fa', '#a78bfa', '#f97316', '#f43f5e', '#facc15', '#94a3b8'];
const ReportsAnalytics: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [timeRange, setTimeRange] = useState('This Year');
  const [mdaFilter, setMdaFilter] = useState('All');
  const [reportType, setReportType] = useState('Revenue');
  const [revenueData, setRevenueData] = useState<any[]>([]);
  const [applicationsData, setApplicationsData] = useState<any[]>([]);
  const [paymentMethodData, setPaymentMethodData] = useState<any[]>([]);
  const [serviceCategoryData, setServiceCategoryData] = useState<any[]>([]);
  const [mdaRevenueData, setMdaRevenueData] = useState<any[]>([]);
  const [userDemographicsData, setUserDemographicsData] = useState<any[]>([]);
  const [weeklyTrendsData, setWeeklyTrendsData] = useState<any[]>([]);
  const [topServices, setTopServices] = useState<any[]>([]);
  const [showReportModal, setShowReportModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState<string | null>(null);
  const [dashboardStats, setDashboardStats] = useState({
    totalRevenue: '₦0',
    totalApplications: 0,
    approvalRate: '0%',
    avgProcessingTime: '0',
    growthRate: '0%'
  });
  const {
    hasPermission,
    isSuperAdmin,
    getMdaId,
    getMdaName
  } = useAdminAuth();
  const canExportReports = hasPermission('reports:export');
  useEffect(() => {
    // Simulate loading data
    const timer = setTimeout(() => {
      let filteredRevenueData = [...mockRevenueData];
      let filteredApplicationsData = [...mockApplicationsData];
      let filteredPaymentMethodData = [...mockPaymentMethodData];
      let filteredServiceCategoryData = [...mockServiceCategoryData];
      let filteredMdaRevenueData = [...mockMdaRevenueData];
      let filteredUserDemographicsData = [...mockUserDemographicsData];
      let filteredWeeklyTrendsData = [...mockWeeklyTrendsData];
      let filteredTopServices: any[] = [];
      // If not a super admin, filter data by MDA
      if (!isSuperAdmin()) {
        const mdaName = getMdaName();
        if (mdaName && mockMdaData[mdaName]) {
          filteredRevenueData = mockMdaData[mdaName].revenueData;
          filteredApplicationsData = mockMdaData[mdaName].applicationsData;
          filteredPaymentMethodData = mockMdaData[mdaName].paymentMethodData;
          filteredServiceCategoryData = mockMdaData[mdaName].serviceCategories;
          filteredTopServices = mockMdaData[mdaName].topServices;
        }
      } else {
        // For super admin, get top services across all MDAs
        filteredTopServices = [{
          name: 'Tax Clearance Certificate',
          count: 245,
          growth: 12
        }, {
          name: 'Business Registration',
          count: 210,
          growth: 15
        }, {
          name: "Driver's License Renewal",
          count: 187,
          growth: 8
        }, {
          name: 'Business Permit Renewal',
          count: 187,
          growth: 8
        }, {
          name: 'Vehicle Registration',
          count: 165,
          growth: 12
        }];
      }
      // Calculate dashboard stats
      const totalRevenue = filteredRevenueData.reduce((sum, item) => sum + item.revenue, 0);
      const totalApplications = filteredApplicationsData.reduce((sum, item) => sum + item.submitted, 0);
      const totalApproved = filteredApplicationsData.reduce((sum, item) => sum + item.approved, 0);
      const approvalRate = Math.round(totalApproved / totalApplications * 100);
      // Calculate growth rate compared to previous year
      const currentYearRevenue = filteredRevenueData.reduce((sum, item) => sum + item.revenue, 0);
      const lastYearRevenue = filteredRevenueData.reduce((sum, item) => sum + item.lastYear, 0);
      const growthRate = Math.round((currentYearRevenue - lastYearRevenue) / lastYearRevenue * 100);
      setDashboardStats({
        totalRevenue: `₦${(totalRevenue / 1000000).toFixed(2)}M`,
        totalApplications,
        approvalRate: `${approvalRate}%`,
        avgProcessingTime: '3.5 days',
        growthRate: `${growthRate}%`
      });
      setRevenueData(filteredRevenueData);
      setApplicationsData(filteredApplicationsData);
      setPaymentMethodData(filteredPaymentMethodData);
      setServiceCategoryData(filteredServiceCategoryData);
      setMdaRevenueData(filteredMdaRevenueData);
      setUserDemographicsData(filteredUserDemographicsData);
      setWeeklyTrendsData(filteredWeeklyTrendsData);
      setTopServices(filteredTopServices);
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [isSuperAdmin, getMdaId, getMdaName]);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const toggleDropdown = (dropdown: string) => {
    if (activeDropdown === dropdown) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdown);
    }
  };
  // Get unique MDAs for filter
  const uniqueMdas = Object.keys(mockMdaData);
  // Open report modal
  const openReportModal = (reportType: string) => {
    setSelectedReport(reportType);
    setShowReportModal(true);
  };
  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center bg-gray-100" data-id="element-3005">
        <div className="flex flex-col items-center" data-id="element-3006">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mb-4" data-id="element-3007"></div>
          <p className="text-gray-600" data-id="element-3008">Loading reports and analytics data...</p>
        </div>
      </div>;
  }
  return <div className="flex h-screen bg-gray-100" data-id="element-3009">
      {/* Sidebar - hidden on mobile unless toggled */}
      <div className={`${isSidebarOpen ? 'block' : 'hidden'} lg:block fixed inset-y-0 left-0 z-50 lg:relative lg:z-0`} data-id="element-3010">
        <AdminSidebar data-id="element-3011" />
      </div>
      {/* Backdrop for mobile sidebar */}
      {isSidebarOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" onClick={() => setIsSidebarOpen(false)} data-id="element-3012"></div>}
      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-3013">
        <AdminHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} data-id="element-3014" />
        <main className="flex-1 overflow-y-auto p-4 lg:p-6" data-id="element-3015">
          {/* Page Header */}
          <div className="mb-6" data-id="element-3016">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-3017">
              Reports & Analytics
              {!isSuperAdmin() && <span className="ml-2 text-lg font-normal text-gray-600" data-id="element-3018">
                  ({getMdaName()})
                </span>}
            </h1>
            <p className="text-gray-600 mt-1" data-id="element-3019">
              {isSuperAdmin() ? 'View comprehensive reports and analytics across all MDAs' : `View reports and analytics for ${getMdaName()}`}
            </p>
          </div>
          {/* Dashboard Stats */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4 mb-6" data-id="element-3020">
            {/* Total Revenue */}
            <div className="bg-white rounded-lg shadow p-4" data-id="element-3021">
              <div className="flex justify-between items-start" data-id="element-3022">
                <div data-id="element-3023">
                  <p className="text-sm font-medium text-gray-500" data-id="element-3024">
                    Total Revenue
                  </p>
                  <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-3025">
                    {dashboardStats.totalRevenue}
                  </p>
                </div>
                <div className="p-2 bg-green-100 rounded-md" data-id="element-3026">
                  <DollarSignIcon size={20} className="text-green-600" data-id="element-3027" />
                </div>
              </div>
              <div className="mt-2 flex items-center text-xs text-green-600" data-id="element-3028">
                <ArrowUpIcon size={14} className="mr-1" data-id="element-3029" />
                <span data-id="element-3030">{dashboardStats.growthRate} from last year</span>
              </div>
            </div>
            {/* Total Applications */}
            <div className="bg-white rounded-lg shadow p-4" data-id="element-3031">
              <div className="flex justify-between items-start" data-id="element-3032">
                <div data-id="element-3033">
                  <p className="text-sm font-medium text-gray-500" data-id="element-3034">
                    Total Applications
                  </p>
                  <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-3035">
                    {dashboardStats.totalApplications.toLocaleString()}
                  </p>
                </div>
                <div className="p-2 bg-blue-100 rounded-md" data-id="element-3036">
                  <FileTextIcon size={20} className="text-blue-600" data-id="element-3037" />
                </div>
              </div>
              <div className="mt-2 flex items-center text-xs text-blue-600" data-id="element-3038">
                <ArrowUpIcon size={14} className="mr-1" data-id="element-3039" />
                <span data-id="element-3040">10% from last year</span>
              </div>
            </div>
            {/* Approval Rate */}
            <div className="bg-white rounded-lg shadow p-4" data-id="element-3041">
              <div className="flex justify-between items-start" data-id="element-3042">
                <div data-id="element-3043">
                  <p className="text-sm font-medium text-gray-500" data-id="element-3044">
                    Approval Rate
                  </p>
                  <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-3045">
                    {dashboardStats.approvalRate}
                  </p>
                </div>
                <div className="p-2 bg-green-100 rounded-md" data-id="element-3046">
                  <CheckCircleIcon size={20} className="text-green-600" data-id="element-3047" />
                </div>
              </div>
              <div className="mt-2 flex items-center text-xs text-green-600" data-id="element-3048">
                <ArrowUpIcon size={14} className="mr-1" data-id="element-3049" />
                <span data-id="element-3050">5% from last quarter</span>
              </div>
            </div>
            {/* Avg. Processing Time */}
            <div className="bg-white rounded-lg shadow p-4" data-id="element-3051">
              <div className="flex justify-between items-start" data-id="element-3052">
                <div data-id="element-3053">
                  <p className="text-sm font-medium text-gray-500" data-id="element-3054">
                    Avg. Processing Time
                  </p>
                  <p className="text-2xl font-bold text-gray-900 mt-1" data-id="element-3055">
                    {dashboardStats.avgProcessingTime}
                  </p>
                </div>
                <div className="p-2 bg-yellow-100 rounded-md" data-id="element-3056">
                  <ClockIcon size={20} className="text-yellow-600" data-id="element-3057" />
                </div>
              </div>
              <div className="mt-2 flex items-center text-xs text-green-600" data-id="element-3058">
                <ArrowDownIcon size={14} className="mr-1" data-id="element-3059" />
                <span data-id="element-3060">12% improvement</span>
              </div>
            </div>
            {/* Report Actions - Only visible on larger screens */}
            <div className="bg-white rounded-lg shadow p-4 hidden xl:block" data-id="element-3061">
              <p className="text-sm font-medium text-gray-500 mb-3" data-id="element-3062">
                Quick Actions
              </p>
              <div className="space-y-2" data-id="element-3063">
                <button onClick={() => openReportModal('Revenue')} className="w-full flex items-center justify-between text-sm px-3 py-2 bg-green-50 text-green-700 rounded-md hover:bg-green-100" data-id="element-3064">
                  <span className="flex items-center" data-id="element-3065">
                    <BarChartIcon size={16} className="mr-2" data-id="element-3066" />
                    Revenue Report
                  </span>
                  <ChevronRightIcon size={16} data-id="element-3067" />
                </button>
                <button onClick={() => openReportModal('Applications')} className="w-full flex items-center justify-between text-sm px-3 py-2 bg-blue-50 text-blue-700 rounded-md hover:bg-blue-100" data-id="element-3068">
                  <span className="flex items-center" data-id="element-3069">
                    <FileTextIcon size={16} className="mr-2" data-id="element-3070" />
                    Applications Report
                  </span>
                  <ChevronRightIcon size={16} data-id="element-3071" />
                </button>
              </div>
            </div>
          </div>
          {/* Filters and Actions */}
          <div className="bg-white rounded-lg shadow mb-6 p-4" data-id="element-3072">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-3073">
              <div className="flex flex-wrap gap-2 w-full md:w-auto" data-id="element-3074">
                {/* Time Range Filter */}
                <div className="relative" data-id="element-3075">
                  <button className="flex items-center text-sm bg-white border border-gray-300 rounded-md px-3 py-2" onClick={() => toggleDropdown('timeRange')} data-id="element-3076">
                    <CalendarIcon size={16} className="mr-2" data-id="element-3077" />
                    {timeRange}
                    <ChevronDownIcon size={16} className="ml-2" data-id="element-3078" />
                  </button>
                  {activeDropdown === 'timeRange' && <div className="absolute left-0 mt-1 w-40 bg-white border border-gray-200 rounded-md shadow-lg z-10" data-id="element-3079">
                      <div className="py-1" data-id="element-3080">
                        {['This Week', 'This Month', 'This Quarter', 'This Year', 'Last Year'].map(option => <button key={option} className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" onClick={() => {
                      setTimeRange(option);
                      setActiveDropdown(null);
                    }} data-id="element-3081">
                            {option}
                          </button>)}
                      </div>
                    </div>}
                </div>
                {/* Report Type Filter */}
                <div className="relative" data-id="element-3082">
                  <button className="flex items-center text-sm bg-white border border-gray-300 rounded-md px-3 py-2" onClick={() => toggleDropdown('reportType')} data-id="element-3083">
                    <BarChart2Icon size={16} className="mr-2" data-id="element-3084" />
                    {reportType} Report
                    <ChevronDownIcon size={16} className="ml-2" data-id="element-3085" />
                  </button>
                  {activeDropdown === 'reportType' && <div className="absolute left-0 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10" data-id="element-3086">
                      <div className="py-1" data-id="element-3087">
                        {['Revenue', 'Applications', 'User', 'Service', 'Performance'].map(option => <button key={option} className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" onClick={() => {
                      setReportType(option);
                      setActiveDropdown(null);
                    }} data-id="element-3088">
                            {option} Report
                          </button>)}
                      </div>
                    </div>}
                </div>
                {/* MDA Filter - Only show for Super Admin */}
                {isSuperAdmin() && <div className="relative" data-id="element-3089">
                    <button className="flex items-center text-sm bg-white border border-gray-300 rounded-md px-3 py-2" onClick={() => toggleDropdown('mda')} data-id="element-3090">
                      <BuildingIcon size={16} className="mr-2" data-id="element-3091" />
                      MDA:{' '}
                      {mdaFilter.length > 15 ? mdaFilter.substring(0, 15) + '...' : mdaFilter}
                      <ChevronDownIcon size={16} className="ml-2" data-id="element-3092" />
                    </button>
                    {activeDropdown === 'mda' && <div className="absolute left-0 mt-1 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-10" data-id="element-3093">
                        <div className="py-1 max-h-60 overflow-y-auto" data-id="element-3094">
                          <button className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" onClick={() => {
                      setMdaFilter('All');
                      setActiveDropdown(null);
                    }} data-id="element-3095">
                            All MDAs
                          </button>
                          {uniqueMdas.map(mda => <button key={mda} className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100" onClick={() => {
                      setMdaFilter(mda);
                      setActiveDropdown(null);
                    }} data-id="element-3096">
                              {mda}
                            </button>)}
                        </div>
                      </div>}
                  </div>}
              </div>
              <div className="flex flex-wrap gap-2 w-full md:w-auto" data-id="element-3097">
                {/* Export Button */}
                {canExportReports && <button className="flex items-center text-sm bg-green-50 text-green-600 border border-green-200 rounded-md px-3 py-2 hover:bg-green-100 transition-colors" data-id="element-3098">
                    <DownloadIcon size={16} className="mr-2" data-id="element-3099" />
                    Export Report
                  </button>}
                {/* Print Button */}
                <button className="flex items-center text-sm bg-blue-50 text-blue-600 border border-blue-200 rounded-md px-3 py-2 hover:bg-blue-100 transition-colors" data-id="element-3100">
                  <PrinterIcon size={16} className="mr-2" data-id="element-3101" />
                  Print Report
                </button>
                {/* Share Button */}
                <button className="flex items-center text-sm bg-purple-50 text-purple-600 border border-purple-200 rounded-md px-3 py-2 hover:bg-purple-100 transition-colors" data-id="element-3102">
                  <ShareIcon size={16} className="mr-2" data-id="element-3103" />
                  Share
                </button>
                {/* Refresh Button */}
                <button onClick={() => {
                setIsLoading(true);
                setTimeout(() => setIsLoading(false), 1000);
              }} className="flex items-center text-sm bg-gray-100 text-gray-600 border border-gray-200 rounded-md px-3 py-2 hover:bg-gray-200 transition-colors" data-id="element-3104">
                  <RefreshCwIcon size={16} className="mr-2" data-id="element-3105" />
                  Refresh
                </button>
              </div>
            </div>
          </div>
          {/* Main Charts Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" data-id="element-3106">
            {/* Revenue Trend Chart */}
            <div className="bg-white rounded-lg shadow p-4" data-id="element-3107">
              <div className="flex justify-between items-center mb-4" data-id="element-3108">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-3109">
                  Revenue Trend
                </h3>
                <div className="flex items-center" data-id="element-3110">
                  <button className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200" data-id="element-3111">
                    Monthly
                  </button>
                  <button className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200 ml-2" data-id="element-3112">
                    <InfoIcon size={14} data-id="element-3113" />
                  </button>
                </div>
              </div>
              <div className="h-80" data-id="element-3114">
                <ResponsiveContainer width="100%" height="100%" data-id="element-3115">
                  <AreaChart data={revenueData} margin={{
                  top: 10,
                  right: 30,
                  left: 0,
                  bottom: 0
                }} data-id="element-3116">
                    <CartesianGrid strokeDasharray="3 3" data-id="element-3117" />
                    <XAxis dataKey="month" data-id="element-3118" />
                    <YAxis tickFormatter={value => `₦${value / 1000}K`} data-id="element-3119" />
                    <Tooltip formatter={(value: any) => [`₦${value.toLocaleString()}`, undefined]} labelFormatter={label => `Month: ${label}`} data-id="element-3120" />
                    <Legend data-id="element-3121" />
                    <Area type="monotone" dataKey="revenue" name="Revenue" stroke="#4ade80" fill="#4ade80" fillOpacity={0.3} activeDot={{
                    r: 8
                  }} data-id="element-3122" />
                    <Area type="monotone" dataKey="target" name="Target" stroke="#94a3b8" fill="#94a3b8" fillOpacity={0.1} strokeDasharray="5 5" data-id="element-3123" />
                    <Area type="monotone" dataKey="lastYear" name="Last Year" stroke="#60a5fa" fill="#60a5fa" fillOpacity={0.1} data-id="element-3124" />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
              <div className="mt-4 grid grid-cols-3 gap-2 text-center text-xs" data-id="element-3125">
                <div className="bg-green-50 text-green-700 p-2 rounded-md" data-id="element-3126">
                  <p className="font-medium" data-id="element-3127">Current</p>
                  <p className="text-lg font-bold mt-1" data-id="element-3128">
                    ₦
                    {(revenueData.reduce((sum, item) => sum + item.revenue, 0) / 1000000).toFixed(2)}
                    M
                  </p>
                </div>
                <div className="bg-gray-50 text-gray-700 p-2 rounded-md" data-id="element-3129">
                  <p className="font-medium" data-id="element-3130">Target</p>
                  <p className="text-lg font-bold mt-1" data-id="element-3131">
                    ₦
                    {(revenueData.reduce((sum, item) => sum + item.target, 0) / 1000000).toFixed(2)}
                    M
                  </p>
                </div>
                <div className="bg-blue-50 text-blue-700 p-2 rounded-md" data-id="element-3132">
                  <p className="font-medium" data-id="element-3133">Last Year</p>
                  <p className="text-lg font-bold mt-1" data-id="element-3134">
                    ₦
                    {(revenueData.reduce((sum, item) => sum + item.lastYear, 0) / 1000000).toFixed(2)}
                    M
                  </p>
                </div>
              </div>
            </div>
            {/* Applications Status Chart */}
            <div className="bg-white rounded-lg shadow p-4" data-id="element-3135">
              <div className="flex justify-between items-center mb-4" data-id="element-3136">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-3137">
                  Applications Status
                </h3>
                <div className="flex items-center" data-id="element-3138">
                  <button className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200" data-id="element-3139">
                    Monthly
                  </button>
                  <button className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200 ml-2" data-id="element-3140">
                    <InfoIcon size={14} data-id="element-3141" />
                  </button>
                </div>
              </div>
              <div className="h-80" data-id="element-3142">
                <ResponsiveContainer width="100%" height="100%" data-id="element-3143">
                  <BarChart data={applicationsData} margin={{
                  top: 10,
                  right: 30,
                  left: 0,
                  bottom: 0
                }} data-id="element-3144">
                    <CartesianGrid strokeDasharray="3 3" data-id="element-3145" />
                    <XAxis dataKey="month" data-id="element-3146" />
                    <YAxis data-id="element-3147" />
                    <Tooltip data-id="element-3148" />
                    <Legend data-id="element-3149" />
                    <Bar dataKey="submitted" name="Submitted" stackId="a" fill="#60a5fa" data-id="element-3150" />
                    <Bar dataKey="approved" name="Approved" stackId="a" fill="#4ade80" data-id="element-3151" />
                    <Bar dataKey="rejected" name="Rejected" stackId="a" fill="#f43f5e" data-id="element-3152" />
                    <Bar dataKey="pending" name="Pending" stackId="a" fill="#facc15" data-id="element-3153" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
              <div className="mt-4 grid grid-cols-4 gap-2 text-center text-xs" data-id="element-3154">
                <div className="bg-blue-50 text-blue-700 p-2 rounded-md" data-id="element-3155">
                  <p className="font-medium" data-id="element-3156">Submitted</p>
                  <p className="text-lg font-bold mt-1" data-id="element-3157">
                    {applicationsData.reduce((sum, item) => sum + item.submitted, 0).toLocaleString()}
                  </p>
                </div>
                <div className="bg-green-50 text-green-700 p-2 rounded-md" data-id="element-3158">
                  <p className="font-medium" data-id="element-3159">Approved</p>
                  <p className="text-lg font-bold mt-1" data-id="element-3160">
                    {applicationsData.reduce((sum, item) => sum + item.approved, 0).toLocaleString()}
                  </p>
                </div>
                <div className="bg-red-50 text-red-700 p-2 rounded-md" data-id="element-3161">
                  <p className="font-medium" data-id="element-3162">Rejected</p>
                  <p className="text-lg font-bold mt-1" data-id="element-3163">
                    {applicationsData.reduce((sum, item) => sum + item.rejected, 0).toLocaleString()}
                  </p>
                </div>
                <div className="bg-yellow-50 text-yellow-700 p-2 rounded-md" data-id="element-3164">
                  <p className="font-medium" data-id="element-3165">Pending</p>
                  <p className="text-lg font-bold mt-1" data-id="element-3166">
                    {applicationsData.reduce((sum, item) => sum + item.pending, 0).toLocaleString()}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Secondary Charts Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mb-6" data-id="element-3167">
            {/* Payment Methods Chart */}
            <div className="bg-white rounded-lg shadow p-4" data-id="element-3168">
              <div className="flex justify-between items-center mb-4" data-id="element-3169">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-3170">
                  Payment Methods
                </h3>
                <button className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200" data-id="element-3171">
                  <InfoIcon size={14} data-id="element-3172" />
                </button>
              </div>
              <div className="h-64" data-id="element-3173">
                <ResponsiveContainer width="100%" height="100%" data-id="element-3174">
                  <PieChart data-id="element-3175">
                    <Pie data={paymentMethodData} cx="50%" cy="50%" labelLine={false} label={({
                    name,
                    percent
                  }) => `${name}: ${(percent * 100).toFixed(0)}%`} outerRadius={80} fill="#8884d8" dataKey="value" data-id="element-3176">
                      {paymentMethodData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-3177" />)}
                    </Pie>
                    <Tooltip formatter={value => [`${value}%`, 'Percentage']} data-id="element-3178" />
                  </PieChart>
                </ResponsiveContainer>
              </div>
              <div className="mt-4 flex flex-wrap justify-center gap-2 text-xs" data-id="element-3179">
                {paymentMethodData.map((method, index) => <div key={index} className="flex items-center" data-id="element-3180">
                    <span className="w-3 h-3 rounded-full mr-1" style={{
                  backgroundColor: COLORS[index % COLORS.length]
                }} data-id="element-3181"></span>
                    <span className="text-gray-600" data-id="element-3182">{method.name}</span>
                  </div>)}
              </div>
            </div>
            {/* Service Categories Chart */}
            <div className="bg-white rounded-lg shadow p-4" data-id="element-3183">
              <div className="flex justify-between items-center mb-4" data-id="element-3184">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-3185">
                  Service Categories
                </h3>
                <button className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200" data-id="element-3186">
                  <InfoIcon size={14} data-id="element-3187" />
                </button>
              </div>
              <div className="h-64" data-id="element-3188">
                <ResponsiveContainer width="100%" height="100%" data-id="element-3189">
                  <PieChart data-id="element-3190">
                    <Pie data={serviceCategoryData} cx="50%" cy="50%" labelLine={false} label={({
                    name,
                    percent
                  }) => `${name}: ${(percent * 100).toFixed(0)}%`} outerRadius={80} fill="#8884d8" dataKey="value" data-id="element-3191">
                      {serviceCategoryData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-3192" />)}
                    </Pie>
                    <Tooltip formatter={value => [`${value}%`, 'Percentage']} data-id="element-3193" />
                  </PieChart>
                </ResponsiveContainer>
              </div>
              <div className="mt-4 flex flex-wrap justify-center gap-2 text-xs" data-id="element-3194">
                {serviceCategoryData.map((category, index) => <div key={index} className="flex items-center" data-id="element-3195">
                    <span className="w-3 h-3 rounded-full mr-1" style={{
                  backgroundColor: COLORS[index % COLORS.length]
                }} data-id="element-3196"></span>
                    <span className="text-gray-600" data-id="element-3197">{category.name}</span>
                  </div>)}
              </div>
            </div>
            {/* Weekly Trends Chart */}
            <div className="bg-white rounded-lg shadow p-4" data-id="element-3198">
              <div className="flex justify-between items-center mb-4" data-id="element-3199">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-3200">
                  Weekly Trends
                </h3>
                <button className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200" data-id="element-3201">
                  <InfoIcon size={14} data-id="element-3202" />
                </button>
              </div>
              <div className="h-64" data-id="element-3203">
                <ResponsiveContainer width="100%" height="100%" data-id="element-3204">
                  <LineChart data={weeklyTrendsData} margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5
                }} data-id="element-3205">
                    <CartesianGrid strokeDasharray="3 3" data-id="element-3206" />
                    <XAxis dataKey="day" data-id="element-3207" />
                    <YAxis data-id="element-3208" />
                    <Tooltip data-id="element-3209" />
                    <Legend data-id="element-3210" />
                    <Line type="monotone" dataKey="applications" name="Applications" stroke="#60a5fa" activeDot={{
                    r: 8
                  }} data-id="element-3211" />
                    <Line type="monotone" dataKey="payments" name="Payments" stroke="#4ade80" data-id="element-3212" />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
          {/* MDA Revenue Distribution - Only show for Super Admin */}
          {isSuperAdmin() && <div className="bg-white rounded-lg shadow p-4 mb-6" data-id="element-3213">
              <div className="flex justify-between items-center mb-4" data-id="element-3214">
                <h3 className="text-lg font-medium text-gray-900" data-id="element-3215">
                  MDA Revenue Distribution
                </h3>
                <button className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200" data-id="element-3216">
                  <InfoIcon size={14} data-id="element-3217" />
                </button>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-3218">
                <div className="h-80" data-id="element-3219">
                  <ResponsiveContainer width="100%" height="100%" data-id="element-3220">
                    <PieChart data-id="element-3221">
                      <Pie data={mdaRevenueData} cx="50%" cy="50%" labelLine={false} label={({
                    name,
                    percent
                  }) => `${name}: ${(percent * 100).toFixed(0)}%`} outerRadius={100} fill="#8884d8" dataKey="value" data-id="element-3222">
                        {mdaRevenueData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.fill || COLORS[index % COLORS.length]} data-id="element-3223" />)}
                      </Pie>
                      <Tooltip formatter={value => [`${value}%`, 'Percentage']} data-id="element-3224" />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
                <div className="flex flex-col justify-center" data-id="element-3225">
                  <h4 className="text-sm font-medium text-gray-700 mb-4" data-id="element-3226">
                    Top Contributing MDAs
                  </h4>
                  <div className="space-y-4" data-id="element-3227">
                    {mdaRevenueData.slice(0, 5).map((mda, index) => <div key={index} className="flex items-center" data-id="element-3228">
                        <div className="w-8 h-8 rounded-full flex items-center justify-center mr-3" style={{
                    backgroundColor: mda.fill || COLORS[index % COLORS.length]
                  }} data-id="element-3229">
                          <span className="text-white font-medium" data-id="element-3230">
                            {index + 1}
                          </span>
                        </div>
                        <div className="flex-1" data-id="element-3231">
                          <div className="flex justify-between items-center" data-id="element-3232">
                            <span className="text-sm font-medium text-gray-900" data-id="element-3233">
                              {mda.name}
                            </span>
                            <span className="text-sm font-medium text-gray-900" data-id="element-3234">
                              {mda.value}%
                            </span>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-3235">
                            <div className="h-1.5 rounded-full" style={{
                        width: `${mda.value}%`,
                        backgroundColor: mda.fill || COLORS[index % COLORS.length]
                      }} data-id="element-3236"></div>
                          </div>
                        </div>
                      </div>)}
                  </div>
                  <button className="mt-4 text-sm text-green-600 hover:text-green-800 flex items-center justify-center" data-id="element-3237">
                    View All MDAs
                    <ChevronRightIcon size={16} className="ml-1" data-id="element-3238" />
                  </button>
                </div>
              </div>
            </div>}
          {/* Top Services */}
          <div className="bg-white rounded-lg shadow p-4 mb-6" data-id="element-3239">
            <div className="flex justify-between items-center mb-4" data-id="element-3240">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-3241">
                Top Services by Volume
              </h3>
              <button className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200" data-id="element-3242">
                <InfoIcon size={14} data-id="element-3243" />
              </button>
            </div>
            <div className="overflow-x-auto" data-id="element-3244">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-3245">
                <thead className="bg-gray-50" data-id="element-3246">
                  <tr data-id="element-3247">
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3248">
                      Service
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3249">
                      Applications
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3250">
                      Growth
                    </th>
                    {isSuperAdmin() && <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3251">
                        MDA
                      </th>}
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-3252">
                      Trend
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-3253">
                  {topServices.map((service, index) => <tr key={index} className="hover:bg-gray-50" data-id="element-3254">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-3255">
                        {service.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-3256">
                        {service.count.toLocaleString()}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-3257">
                        <div className={`flex items-center ${service.growth >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-3258">
                          {service.growth >= 0 ? <ArrowUpIcon size={16} className="mr-1" data-id="element-3259" /> : <ArrowDownIcon size={16} className="mr-1" data-id="element-3260" />}
                          <span className="text-sm font-medium" data-id="element-3261">
                            {Math.abs(service.growth)}%
                          </span>
                        </div>
                      </td>
                      {isSuperAdmin() && <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-3262">
                          <span className="bg-gray-100 text-gray-800 text-xs font-medium px-2 py-1 rounded" data-id="element-3263">
                            {index === 0 ? 'MOF' : index === 1 ? 'MCI' : index === 2 ? 'FRSC' : index === 3 ? 'MOF' : 'FRSC'}
                          </span>
                        </td>}
                      <td className="px-6 py-4 whitespace-nowrap" data-id="element-3264">
                        <div className="w-20 h-8" data-id="element-3265">
                          <ResponsiveContainer width="100%" height="100%" data-id="element-3266">
                            <LineChart data={[{
                          value: Math.random() * 100
                        }, {
                          value: Math.random() * 100
                        }, {
                          value: Math.random() * 100
                        }, {
                          value: Math.random() * 100
                        }, {
                          value: Math.random() * 100
                        }, {
                          value: Math.random() * 100
                        }]} data-id="element-3267">
                              <Line type="monotone" dataKey="value" stroke={service.growth >= 0 ? '#4ade80' : '#f43f5e'} strokeWidth={2} dot={false} data-id="element-3268" />
                            </LineChart>
                          </ResponsiveContainer>
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
            <div className="mt-4 flex justify-center" data-id="element-3269">
              <button className="text-sm text-green-600 hover:text-green-800 flex items-center" data-id="element-3270">
                View All Services
                <ChevronRightIcon size={16} className="ml-1" data-id="element-3271" />
              </button>
            </div>
          </div>
          {/* Report Generation Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-6" data-id="element-3272">
            <div className="bg-white rounded-lg shadow p-4 hover:shadow-md transition-shadow" data-id="element-3273">
              <div className="flex items-center mb-4" data-id="element-3274">
                <div className="p-2 bg-green-100 rounded-md mr-3" data-id="element-3275">
                  <BarChartIcon size={20} className="text-green-600" data-id="element-3276" />
                </div>
                <h3 className="text-lg font-medium text-gray-900" data-id="element-3277">
                  Revenue Report
                </h3>
              </div>
              <p className="text-sm text-gray-600 mb-4" data-id="element-3278">
                Comprehensive analysis of revenue streams across all payment
                channels.
              </p>
              <button onClick={() => openReportModal('Revenue')} className="w-full flex items-center justify-center text-sm px-3 py-2 bg-green-50 text-green-700 rounded-md hover:bg-green-100" data-id="element-3279">
                Generate Report
                <ArrowRightIcon size={16} className="ml-2" data-id="element-3280" />
              </button>
            </div>
            <div className="bg-white rounded-lg shadow p-4 hover:shadow-md transition-shadow" data-id="element-3281">
              <div className="flex items-center mb-4" data-id="element-3282">
                <div className="p-2 bg-blue-100 rounded-md mr-3" data-id="element-3283">
                  <FileTextIcon size={20} className="text-blue-600" data-id="element-3284" />
                </div>
                <h3 className="text-lg font-medium text-gray-900" data-id="element-3285">
                  Applications Report
                </h3>
              </div>
              <p className="text-sm text-gray-600 mb-4" data-id="element-3286">
                Detailed statistics on application submissions, approvals, and
                processing times.
              </p>
              <button onClick={() => openReportModal('Applications')} className="w-full flex items-center justify-center text-sm px-3 py-2 bg-blue-50 text-blue-700 rounded-md hover:bg-blue-100" data-id="element-3287">
                Generate Report
                <ArrowRightIcon size={16} className="ml-2" data-id="element-3288" />
              </button>
            </div>
            <div className="bg-white rounded-lg shadow p-4 hover:shadow-md transition-shadow" data-id="element-3289">
              <div className="flex items-center mb-4" data-id="element-3290">
                <div className="p-2 bg-purple-100 rounded-md mr-3" data-id="element-3291">
                  <UsersIcon size={20} className="text-purple-600" data-id="element-3292" />
                </div>
                <h3 className="text-lg font-medium text-gray-900" data-id="element-3293">
                  User Demographics
                </h3>
              </div>
              <p className="text-sm text-gray-600 mb-4" data-id="element-3294">
                Analysis of user demographics, registration trends, and
                engagement metrics.
              </p>
              <button onClick={() => openReportModal('User')} className="w-full flex items-center justify-center text-sm px-3 py-2 bg-purple-50 text-purple-700 rounded-md hover:bg-purple-100" data-id="element-3295">
                Generate Report
                <ArrowRightIcon size={16} className="ml-2" data-id="element-3296" />
              </button>
            </div>
            <div className="bg-white rounded-lg shadow p-4 hover:shadow-md transition-shadow" data-id="element-3297">
              <div className="flex items-center mb-4" data-id="element-3298">
                <div className="p-2 bg-orange-100 rounded-md mr-3" data-id="element-3299">
                  <CreditCardIcon size={20} className="text-orange-600" data-id="element-3300" />
                </div>
                <h3 className="text-lg font-medium text-gray-900" data-id="element-3301">
                  Payment Analysis
                </h3>
              </div>
              <p className="text-sm text-gray-600 mb-4" data-id="element-3302">
                Insights into payment methods, transaction success rates, and
                payment trends.
              </p>
              <button onClick={() => openReportModal('Payment')} className="w-full flex items-center justify-center text-sm px-3 py-2 bg-orange-50 text-orange-700 rounded-md hover:bg-orange-100" data-id="element-3303">
                Generate Report
                <ArrowRightIcon size={16} className="ml-2" data-id="element-3304" />
              </button>
            </div>
          </div>
          {/* Help & Resources */}
          <div className="bg-white rounded-lg shadow p-4 mb-6" data-id="element-3305">
            <div className="flex justify-between items-center mb-4" data-id="element-3306">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-3307">
                Help & Resources
              </h3>
              <button className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-md hover:bg-gray-200" data-id="element-3308">
                <MoreHorizontalIcon size={14} data-id="element-3309" />
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-3310">
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-3311">
                <div className="flex items-start" data-id="element-3312">
                  <div className="p-2 bg-blue-100 rounded-md mr-3" data-id="element-3313">
                    <HelpCircleIcon size={20} className="text-blue-600" data-id="element-3314" />
                  </div>
                  <div data-id="element-3315">
                    <h4 className="text-sm font-medium text-gray-900 mb-1" data-id="element-3316">
                      Report Guides
                    </h4>
                    <p className="text-xs text-gray-600 mb-2" data-id="element-3317">
                      Learn how to create and interpret different types of
                      reports.
                    </p>
                    <a href="#" className="text-xs text-blue-600 hover:text-blue-800 flex items-center" data-id="element-3318">
                      View Guides
                      <ChevronRightIcon size={14} className="ml-1" data-id="element-3319" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-3320">
                <div className="flex items-start" data-id="element-3321">
                  <div className="p-2 bg-purple-100 rounded-md mr-3" data-id="element-3322">
                    <MailIcon size={20} className="text-purple-600" data-id="element-3323" />
                  </div>
                  <div data-id="element-3324">
                    <h4 className="text-sm font-medium text-gray-900 mb-1" data-id="element-3325">
                      Schedule Reports
                    </h4>
                    <p className="text-xs text-gray-600 mb-2" data-id="element-3326">
                      Set up automated reports to be delivered to your email.
                    </p>
                    <a href="#" className="text-xs text-purple-600 hover:text-purple-800 flex items-center" data-id="element-3327">
                      Schedule Now
                      <ChevronRightIcon size={14} className="ml-1" data-id="element-3328" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg" data-id="element-3329">
                <div className="flex items-start" data-id="element-3330">
                  <div className="p-2 bg-green-100 rounded-md mr-3" data-id="element-3331">
                    <AlertCircleIcon size={20} className="text-green-600" data-id="element-3332" />
                  </div>
                  <div data-id="element-3333">
                    <h4 className="text-sm font-medium text-gray-900 mb-1" data-id="element-3334">
                      Need Help?
                    </h4>
                    <p className="text-xs text-gray-600 mb-2" data-id="element-3335">
                      Contact our support team for assistance with reports and
                      analytics.
                    </p>
                    <a href="#" className="text-xs text-green-600 hover:text-green-800 flex items-center" data-id="element-3336">
                      Get Support
                      <ChevronRightIcon size={14} className="ml-1" data-id="element-3337" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      {/* Report Generation Modal */}
      {showReportModal && selectedReport && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-3338">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full" data-id="element-3339">
            <div className="px-6 py-4 border-b border-gray-200" data-id="element-3340">
              <h3 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-3341">
                {selectedReport === 'Revenue' && <BarChartIcon size={20} className="text-green-600 mr-2" data-id="element-3342" />}
                {selectedReport === 'Applications' && <FileTextIcon size={20} className="text-blue-600 mr-2" data-id="element-3343" />}
                {selectedReport === 'User' && <UsersIcon size={20} className="text-purple-600 mr-2" data-id="element-3344" />}
                {selectedReport === 'Payment' && <CreditCardIcon size={20} className="text-orange-600 mr-2" data-id="element-3345" />}
                Generate {selectedReport} Report
              </h3>
            </div>
            <div className="p-6" data-id="element-3346">
              <div className="mb-4" data-id="element-3347">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3348">
                  Report Title
                </label>
                <input type="text" className="block w-full rounded-md border border-gray-300 py-2 px-3 text-gray-900 focus:ring-1 focus:ring-green-500 focus:border-green-500" placeholder="Enter report title" defaultValue={`${selectedReport} Report - ${new Date().toLocaleDateString()}`} data-id="element-3349" />
              </div>
              <div className="mb-4" data-id="element-3350">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3351">
                  Time Period
                </label>
                <select className="block w-full rounded-md border border-gray-300 py-2 px-3 text-gray-900 focus:ring-1 focus:ring-green-500 focus:border-green-500" data-id="element-3352">
                  <option data-id="element-3353">Last 30 days</option>
                  <option data-id="element-3354">Last 90 days</option>
                  <option data-id="element-3355">Last 6 months</option>
                  <option data-id="element-3356">Last 12 months</option>
                  <option data-id="element-3357">Custom range</option>
                </select>
              </div>
              {isSuperAdmin() && <div className="mb-4" data-id="element-3358">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3359">
                    MDA Filter
                  </label>
                  <select className="block w-full rounded-md border border-gray-300 py-2 px-3 text-gray-900 focus:ring-1 focus:ring-green-500 focus:border-green-500" data-id="element-3360">
                    <option data-id="element-3361">All MDAs</option>
                    {uniqueMdas.map(mda => <option key={mda} data-id="element-3362">{mda}</option>)}
                  </select>
                </div>}
              <div className="mb-4" data-id="element-3363">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3364">
                  Report Format
                </label>
                <div className="grid grid-cols-3 gap-3" data-id="element-3365">
                  <div className="flex items-center border border-gray-300 rounded-md p-3 cursor-pointer bg-green-50 border-green-500" data-id="element-3366">
                    <input type="radio" name="report-format" id="format-pdf" className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300" defaultChecked data-id="element-3367" />
                    <label htmlFor="format-pdf" className="ml-2 block text-sm font-medium text-gray-700" data-id="element-3368">
                      PDF
                    </label>
                  </div>
                  <div className="flex items-center border border-gray-300 rounded-md p-3 cursor-pointer" data-id="element-3369">
                    <input type="radio" name="report-format" id="format-excel" className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300" data-id="element-3370" />
                    <label htmlFor="format-excel" className="ml-2 block text-sm font-medium text-gray-700" data-id="element-3371">
                      Excel
                    </label>
                  </div>
                  <div className="flex items-center border border-gray-300 rounded-md p-3 cursor-pointer" data-id="element-3372">
                    <input type="radio" name="report-format" id="format-csv" className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300" data-id="element-3373" />
                    <label htmlFor="format-csv" className="ml-2 block text-sm font-medium text-gray-700" data-id="element-3374">
                      CSV
                    </label>
                  </div>
                </div>
              </div>
              <div className="mb-6" data-id="element-3375">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3376">
                  Report Components
                </label>
                <div className="space-y-2" data-id="element-3377">
                  <div className="flex items-center" data-id="element-3378">
                    <input type="checkbox" id="include-summary" className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded" defaultChecked data-id="element-3379" />
                    <label htmlFor="include-summary" className="ml-2 block text-sm text-gray-700" data-id="element-3380">
                      Executive Summary
                    </label>
                  </div>
                  <div className="flex items-center" data-id="element-3381">
                    <input type="checkbox" id="include-charts" className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded" defaultChecked data-id="element-3382" />
                    <label htmlFor="include-charts" className="ml-2 block text-sm text-gray-700" data-id="element-3383">
                      Charts and Visualizations
                    </label>
                  </div>
                  <div className="flex items-center" data-id="element-3384">
                    <input type="checkbox" id="include-tables" className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded" defaultChecked data-id="element-3385" />
                    <label htmlFor="include-tables" className="ml-2 block text-sm text-gray-700" data-id="element-3386">
                      Detailed Data Tables
                    </label>
                  </div>
                  <div className="flex items-center" data-id="element-3387">
                    <input type="checkbox" id="include-trends" className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded" defaultChecked data-id="element-3388" />
                    <label htmlFor="include-trends" className="ml-2 block text-sm text-gray-700" data-id="element-3389">
                      Trend Analysis
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-between space-x-3" data-id="element-3390">
                <button onClick={() => setShowReportModal(false)} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50" data-id="element-3391">
                  Cancel
                </button>
                <div className="flex space-x-3" data-id="element-3392">
                  <button onClick={() => setShowReportModal(false)} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-blue-600 bg-blue-50 hover:bg-blue-100" data-id="element-3393">
                    Preview
                  </button>
                  <button onClick={() => setShowReportModal(false)} className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700" data-id="element-3394">
                    Generate Report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};
export default ReportsAnalytics;